import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import { listPublicPosts } from "../../../features/blog/api";
import { formatBlogDate } from "../../../features/blog/blogUtils";
import Reveal from "../components/Reveal";
import { useSteffiCopy } from "../content";

export default function LatestBlogSection() {
  const { BLOG } = useSteffiCopy();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const controller = new AbortController();
    listPublicPosts({ limit: 3, signal: controller.signal })
      .then(({ items }) => setPosts(items))
      .catch((error) => {
        if (error.name !== "AbortError") console.warn("Blog posts could not be loaded", error);
      });
    return () => controller.abort();
  }, []);

  if (posts.length === 0) return null;

  return (
    <section className="bg-[color:var(--bg)] py-28 lg:py-40" aria-labelledby="latest-blog-title">
      <div className="mx-auto w-full max-w-[1440px] px-6 lg:px-10">
        <Reveal className="flex flex-col items-start justify-between gap-8 sm:flex-row sm:items-end">
          <div>
            <p className="t-eyebrow">{BLOG.eyebrow}</p>
            <h2 id="latest-blog-title" className="t-section mt-5">{BLOG.title}</h2>
          </div>
          <Link to="/blog" className="btn btn-ghost !px-6 !py-3 !text-[0.9375rem]">
            {BLOG.all} <FiArrowRight aria-hidden />
          </Link>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {posts.map((post, index) => (
            <Reveal key={post.id} delay={index * 90}>
              <article className="card h-full overflow-hidden">
                <Link to={`/blog/${post.slug}`} className="block aspect-[16/10] overflow-hidden bg-[color:var(--bg-2)]">
                  {post.cover_image_url ? (
                    <img src={post.cover_image_url} alt={post.cover_image_alt || ""} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 hover:scale-[1.035]" />
                  ) : (
                    <span className="display flex h-full items-center justify-center text-[1.2rem] text-[color:var(--accent)]">SteffiCare</span>
                  )}
                </Link>
                <div className="p-7 lg:p-8">
                  <p className="t-eyebrow !text-[0.7rem]">{formatBlogDate(post.published_at)}</p>
                  <h3 className="t-feature mt-4 !text-[clamp(1.35rem,1.8vw,1.9rem)]">
                    <Link to={`/blog/${post.slug}`} className="transition-opacity hover:opacity-65">{post.title}</Link>
                  </h3>
                  <p className="mt-4 text-[1rem] leading-7 text-[color:var(--ink-2)]">{post.excerpt}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
